// extracted by mini-css-extract-plugin
export default {"cls1":"HDZGfw0xoAnUstORPCa6","cls2":"DJYwP19RAwk3J12ggrsM HDZGfw0xoAnUstORPCa6"};